import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import {IMembershipVehicleList  } from "../../../Pages/MembershipVehicle/IMembershipVehicle";

export const MembershipVehicleSlicer = createSlice({
  name: "MembershipVehicle",
  initialState: {
    data: {},
    isLoading: false,
  } as IReduxState<IMembershipVehicleList[]>,
  reducers: {
    getMembershipVehicle: (state, _) => {
      state.isLoading = true;
    },
    successGetMembershipVehicle: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureGetMembershipVehicle: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
  },
});

export const { getMembershipVehicle, failureGetMembershipVehicle, successGetMembershipVehicle } =
  MembershipVehicleSlicer.actions;

export default MembershipVehicleSlicer.reducer;
